var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"logo"},[_c('svg-icon',{attrs:{"name":_vm.name,"height":_vm.height,"width":_vm._width}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }